import React from "react";
import PropTypes from "prop-types";
import "./DateRange.scss"; // Import your custom CSS
import ReactDatePicker from "react-datepicker";
//TODO:KP: remove unused vaiable and add disbale and read only 
const DatePicker = ({
    selected,
    onChange, // Use onClick instead of onChange for handling the button click
    placeholder,
    onBlur,
    isDisable,
    isTime
}) => {
    const handleButtonClick = (e) => {
        if (onChange) {
            onChange(e);
        }
    };

    const getDatePickerProps = (isTime) => {
        return isTime
      ? {
          // showTimeSelect: true,
          // showTimeSelectOnly: true,
          // timeIntervals: 15,
          // timeCaption: "Time",
          // dateFormat: "h:mm aa",
          showTimeSelectOnly: true,
          timeInputLabel:"Time:",
          dateFormat:"h:mm aa",
          showTimeInput:true
      }
      : {
        //   minDate: minDate,
          showMonthDropdown: true,
          showYearDropdown: true,
          scrollableYearDropdown: true,
          scrollableMonthYearDropdown: true,
          yearDropdownItemNumber: 50,
          adjustDateOnChange: true,
          dateFormat: "dd/MM/yyyy", // Format for date picker
      };
    };

    // const handleBlur = () => {
    //     if (onBlur) {
    //         onBlur()
    //     }
    // };

    return (
        <div className="date-picker">
            <ReactDatePicker
                placeholderText={placeholder}
                selected={selected}
                onChange={(e) => handleButtonClick(e)}
                onBlur={onBlur}
                autoComplete="off"
                disabled={isDisable}
                dateFormat={"dd/MM/yyyy"}
                {...getDatePickerProps(isTime)}
            />
        </div>
    );
};

DatePicker.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func, // Use onClick for handling the button click
    cssClass: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
};

export default DatePicker;
